module.exports = __webpack_public_path__ + "img/rpicon.2a9551e7.svg";